import React, { useState, useEffect, useRef } from 'react';
import { CatIcon,Github,FileText, Linkedin, Mail, ExternalLink, Menu, X, Shield, Code, Server, Cpu, Instagram, MessageCircle, User, Briefcase, Send, ChevronDown } from 'lucide-react';
import LoadingScreen from '../components/LoadingScreen';
const useScrollReveal = (threshold = 0.1) => {
  const [elements, setElements] = useState([]);
  const observer = useRef(null);

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-reveal');
          observer.current.unobserve(entry.target);
        }
      });
    }, { threshold });

    elements.forEach(el => {
      if (el) observer.current.observe(el);
    });

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [elements, threshold]);

  const ref = (el) => {
    if (el && !elements.includes(el)) {
      setElements(prev => [...prev, el]);
    }
  };

  return ref;
};

const Portfolio = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [showAllProjects, setShowAllProjects] = useState(false);

  const revealRef = useScrollReveal(0.1);
  useEffect(() => {
    // Simulate loading time or wait for resources
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // Adjust timing as needed (2 seconds in this example)
    
    return () => clearTimeout(timer);
  }, []);
  const projects = [
    {
      id: 1,
      title: "Aliens Eye",
      description: "Hunt down 800+ social media accounts using AI . OSINT tool.",
      imageUrl: "https://raw.githubusercontent.com/arxhr007/Aliens_eye/refs/heads/main/photos/photo.png", 
      technologies: ["Python", "bash"],
      codeLink: "https://github.com/arxhr007/Aliens_eye",
      liveLink: "https://github.com/arxhr007/Aliens_eye",
      linkText: "",
      borderHoverColor: "hover:border-cyan-500",
      textColor: "text-cyan-400",
      hoverColor: "hover:text-cyan-300",
    },
    {
      id: 2,
      title: "Amma",
      description: "A malayalam Programming language created with rust.",
      imageUrl: "https://camo.githubusercontent.com/48ecdba213697c4393b7461e9e368f1e4309ac37c50037e30eafa5d14a89e5fb/68747470733a2f2f692e6962622e636f2f674c445956734a382f616d6d612e706e67", 
      technologies: ["Rust"],
      codeLink: "https://github.com/arxhr007/amma",
      liveLink: "https://github.com/arxhr007/amma",
      borderHoverColor: "hover:border-green-500",
      textColor: "text-green-400",
      hoverColor: "hover:text-green-300",
    },
    {
      id: 3,
      title: "Nyxora",
      description: "A webpage for storing dreams and interpreting its meaning using AI , also analyze sleep.",
      imageUrl: "/assets/nyxora.png", 
      technologies: ["React", "Tailwind", "Firebase"],
      codeLink: "https://github.com/arxhr007/nyxora",
      liveLink: "https://nyxora.vercel.app/",
      linkText: "Live Demo",
      borderHoverColor: "hover:border-purple-500",
      textColor: "text-purple-400",
      hoverColor: "hover:text-purple-300",
    },
    {
      id: 4,
      title: "Wifi-Strike",
      description: "Pure python Automated wifi deauther and packet injection.",
      imageUrl: "https://raw.githubusercontent.com/arxhr007/wifistrike/main/img/Screenshot%20from%202024-08-02%2019-44-52.png", 
      technologies: ["Python", "Bash"],
      codeLink: "https://github.com/arxhr007/wifistrike",
      liveLink: "https://github.com/arxhr007/wifistrike",
      color: "from-red-500 to-red-600",
      borderHoverColor: "hover:border-red-500",
      textColor: "text-red-400",
      hoverColor: "hover:text-red-300",
    },
    {
      id: 5,
      title: "Malware-Sandbox-Evasion",
      description: "Advanced Malware Sandbox Detection and Evasion: A Technical Guide",
      imageUrl: "https://media.licdn.com/dms/image/C4D12AQE_g_iqBXa-9A/article-cover_image-shrink_720_1280/0/1645363067576?e=2147483647&v=beta&t=FUq9HwDGnanEjO9g32lVL8gxpV_65ypOjKxROPw1JHg", 
      technologies: ["c", "MarkDown"],
      codeLink: "https://github.com/arxhr007/Malware-Sandbox-Evasion",
      liveLink: "https://github.com/arxhr007/Malware-Sandbox-Evasion",
      linkText: "",
      borderHoverColor: "hover:border-green-500",
      textColor: "text-green-400",
      hoverColor: "hover:text-green-300",
    },
    {
      id: 6,
      title: "ETlab-Scrapper",
      description: "Web app for scraping attendance and calculating statistics from an ET-lab.",
      imageUrl: "/assets/etlab.png", 
      technologies: ["Html", "Tailwind", "js", "python", "flask"],
      linkText: "Live Demo",

      codeLink: "https://github.com/arxhr007/bunk",
      liveLink: "https://bunk.vercel.app/",
      color: "from-cyan-500 to-blue-600",
      borderHoverColor: "hover:border-cyan-500",
      textColor: "text-cyan-400",
      hoverColor: "hover:text-cyan-300",
    },
    {
      id: 7,
      title: "AI-IoT-Traffic_light ",
      description: "AI based traffic light controlled by ardino UNO.",
      imageUrl: "https://cdn.analyticsvidhya.com/wp-content/uploads/2018/12/Screenshot-from-2018-11-29-13-03-17.png", 
      technologies: ["Python", "c++", "Arduino"],
      codeLink: "https://github.com/arxhr007/AI-IoT-Traffic_light",
      liveLink: "https://github.com/arxhr007/AI-IoT-Traffic_light",
      color: "from-purple-500 to-purple-600",
      borderHoverColor: "hover:border-purple-500",
      textColor: "text-purple-400",
      hoverColor: "hover:text-purple-300",
    },
    {
      id: 8,
      title: "Gamer-Tux",
      description: "Play games in linux terminal",
      imageUrl: "https://raw.githubusercontent.com/arxhr007/Gamer-tux/main/photos/screenshot.png", 
      technologies: ["bash"],
      codeLink: "https://github.com/arxhr007/Gamer-tux",
      liveLink: "https://github.com/arxhr007/Gamer-tux",
      borderHoverColor: "hover:border-red-500",
      textColor: "text-red-400",
      hoverColor: "hover:text-red-300",
    }
  ];

  const navLinks = [
    { name: "About", href: "#about", icon: <User size={18} /> },
    { name: "Skills", href: "#skills", icon: <Code size={18} /> },
    { name: "Projects", href: "#projects", icon: <Briefcase size={18} /> },
    { name: "blog", href: "/blog", icon: <FileText size={18} /> },

  ];

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setShowNavbar(false);

        if (isMenuOpen) {
          setIsMenuOpen(false);
        }
      } else {
        setShowNavbar(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY, isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleShowAllProjects = () => {
    setShowAllProjects(!showAllProjects);
  };

  const visibleProjects = showAllProjects ? projects : projects.slice(0, 4);

  return (
    <>
    {isLoading ? (
      <LoadingScreen />
    ) : (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      {}
      <style jsx global>{`
        .animate-reveal {
          animation: reveal 0.8s ease forwards;
        }

        @keyframes reveal {
          0% {
            opacity: 0;
            transform: translateY(30px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .reveal-element {
          opacity: 0;
          transform: translateY(30px);
        }

        .staggered-reveal > * {
          opacity: 0;
          transform: translateY(20px);
          transition: opacity 0.5s ease, transform 0.5s ease;
        }

        .staggered-reveal > *:nth-child(1) { transition-delay: 0.1s; }
        .staggered-reveal > *:nth-child(2) { transition-delay: 0.2s; }
        .staggered-reveal > *:nth-child(3) { transition-delay: 0.3s; }
        .staggered-reveal > *:nth-child(4) { transition-delay: 0.4s; }
        .staggered-reveal > *:nth-child(5) { transition-delay: 0.5s; }

        .animate-reveal.staggered-reveal > * {
          opacity: 1;
          transform: translateY(0);
        }

        .nav-link {
          position: relative;
          transition: all 0.3s ease;
        }

        .nav-link::after {
          content: '';
          position: absolute;
          width: 0;
          height: 2px;
          bottom: -4px;
          left: 0;
          background: linear-gradient(to right, #2dd4bf, #a855f7);
          transition: width 0.3s ease;
        }

        .nav-link:hover::after {
          width: 100%;
        }
      `}</style>

      {}
      <nav className={`fixed w-full z-10 bg-gray-900 bg-opacity-95 border-b border-gray-800 shadow-lg transition-transform duration-300 ${showNavbar ? 'translate-y-0' : '-translate-y-full'}`}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <CatIcon size={20} className="text-cyan-400 mr-2" />
              <span className="font-bold text-xl text-cyan-400">ARXHR<span className="text-purple-400">007</span></span>
            </div>

            {}
            <div className="hidden md:flex items-center space-x-8">
              {navLinks.map((link) => (
                <a 
                  key={link.name}
                  href={link.href} 
                  className="nav-link flex items-center space-x-2 text-gray-300 hover:text-cyan-400 transition-colors duration-300"
                >
                  {link.icon}
                  <span>{link.name}</span>
                </a>
              ))}
              <a 
                href="#contact" 
                className="bg-gradient-to-r from-cyan-500 to-purple-500 hover:from-cyan-600 hover:to-purple-600 text-white px-5 py-2 rounded-md flex items-center space-x-2 transition-all duration-300 shadow-lg hover:shadow-cyan-500/20"
              >
                <Send size={18} />
                <span>Contact</span>
              </a>
            </div>

            {}
            <div className="md:hidden flex items-center">
              <button onClick={toggleMenu} className="text-gray-300 hover:text-white focus:outline-none">
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>

        {}
        <div 
          className={`md:hidden bg-gray-800 transition-all duration-300 ease-in-out overflow-hidden ${
            isMenuOpen ? 'max-h-70 opacity-100 visible' : 'max-h-0 opacity-0 invisible'
          }`}
        >
          <div className="px-4 pt-2 pb-3">
            {navLinks.map((link) => (
              <a 
                key={link.name}
                href={link.href} 
                className="flex items-center space-x-3 py-3 px-2 hover:bg-gray-700 rounded-md text-gray-300 hover:text-cyan-400 transition-all duration-200" 
                onClick={toggleMenu}
              >
                {link.icon}
                <span>{link.name}</span>
              </a>
            ))}
            <a 
              href="/#contact" 
              className="flex items-center space-x-3 py-3 px-2 mt-2 bg-gradient-to-r from-cyan-500 to-purple-500 rounded-md text-white transition-all duration-200"
              onClick={toggleMenu}
            >
              <Send size={18} />
              <span>Contact</span>
            </a>
          </div>
        </div>
      </nav>

      {}
      <div className={`md:hidden transition-all duration-300 ease-in-out ${isMenuOpen ? 'h-45 md:h-0' : 'h-0'}`}></div>

      {}
      <header id="about" className="pt-24 pb-16 md:pt-32 md:pb-24 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto">
        <div className="grid md:grid-cols-5 gap-8 items-center">
          <div className="md:col-span-3">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 bg-gradient-to-r from-cyan-400 to-purple-500 text-transparent bg-clip-text">Full Stack Developer & Cybersecurity Enthusiast</h1>
            <p className="text-lg text-gray-300 mb-6">Building secure, scalable applications with a focus on privacy and protection. Transforming complex problems into elegant solutions.</p>

            {}
            <div className="flex justify-center space-x-4 mb-6">
              <a href="https://github.com/arxhr007" className="text-gray-300 hover:text-cyan-400 transition-colors duration-300">
                <Github size={24} />
              </a>
              <a href="https://linkedin.com/in/aaron-thomas-16971233a" className="text-gray-300 hover:text-cyan-400 transition-colors duration-300">
                <Linkedin size={24} />
              </a>
              <a href="https://instagram.com/_arxhr007_" className="text-gray-300 hover:text-cyan-400 transition-colors duration-300">
                <Instagram size={24} />
              </a>
              <a href="https://t.me/arxhr007" className="text-gray-300 hover:text-cyan-400 transition-colors duration-300">
                <MessageCircle size={24} />
              </a>
              <a href="mailto:aaron123thomas098@gmail.com" className="text-gray-300 hover:text-cyan-400 transition-colors duration-300">
                <Mail size={24} />
              </a>
            </div>
          </div>
          <div className="md:col-span-2 flex justify-center">
  <div className="relative w-64 h-64 rounded-full overflow-hidden border-4 border-gray-800 shadow-lg bg-gradient-to-br from-cyan-500 to-purple-500">
    <img 
      src="/assets/real.png" 
      alt="Profile Picture" 
      className="w-full h-full object-cover"
    />
  </div>
</div>

        </div>
      </header>

 <section id="skills" className="py-16 bg-gray-800 bg-opacity-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 ref={revealRef} className="text-3xl font-bold mb-12 text-center reveal-element">
            <span className="bg-gradient-to-r from-cyan-400 to-purple-500 text-transparent bg-clip-text">Technical Skills</span>
          </h2>

          <div ref={revealRef} className="grid grid-cols-1 md:grid-cols-4 gap-8 staggered-reveal reveal-element">
            {}
            <div className="bg-gray-800 rounded-lg p-6 shadow-lg border border-gray-700 hover:border-cyan-500 transition-all duration-300">
              <div className="flex items-center mb-4">
                <Code size={24} className="text-cyan-400 mr-2" />
                <h3 className="text-xl font-semibold">Frontend</h3>
              </div>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-cyan-400 rounded-full mr-2"></span>
                  React / Next JS
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-cyan-400 rounded-full mr-2"></span>
                  TypeScript / JavaScript
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-cyan-400 rounded-full mr-2"></span>
                  Tailwind CSS / SASS
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-cyan-400 rounded-full mr-2"></span>
                  Responsive Design
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-cyan-400 rounded-full mr-2"></span>
                  UI/UX Best Practices
                </li>
              </ul>
            </div>

            {}
            <div className="bg-gray-800 rounded-lg p-6 shadow-lg border border-gray-700 hover:border-purple-500 transition-all duration-300">
              <div className="flex items-center mb-4">
                <Server size={24} className="text-purple-400 mr-2" />
                <h3 className="text-xl font-semibold">Backend</h3>
              </div>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-400 rounded-full mr-2"></span>
                  Node.js / Express
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-400 rounded-full mr-2"></span>
                  Python / Django
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-400 rounded-full mr-2"></span>
                  RESTful API Design
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-400 rounded-full mr-2"></span>
                  MongoDB / PostgreSQL
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-400 rounded-full mr-2"></span>
                  Firebase / Docker
                </li>
              </ul>
            </div>

            {}
            <div className="bg-gray-800 rounded-lg p-6 shadow-lg border border-gray-700 hover:border-red-500 transition-all duration-300">
              <div className="flex items-center mb-4">
                <Shield size={24} className="text-red-400 mr-2" />
                <h3 className="text-xl font-semibold">Cybersecurity</h3>
              </div>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-400 rounded-full mr-2"></span>
                  Penetration Testing
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-400 rounded-full mr-2"></span>
                  Malware Analysis
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-400 rounded-full mr-2"></span>
                  Offensive Devlopment
                </li> 
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-400 rounded-full mr-2"></span>
                  Reverse Engineering

                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-400 rounded-full mr-2"></span>
                  Red Teaming
                </li>
              </ul>
            </div>

            {}
            <div className="bg-gray-800 rounded-lg p-6 shadow-lg border border-gray-700 hover:border-green-500 transition-all duration-300">
              <div className="flex items-center mb-4">
                <Cpu size={24} className="text-green-400 mr-2" />
                <h3 className="text-xl font-semibold">Hardware & IoT</h3>
              </div>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                  Arduino & Raspberry Pi
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                  Embedded Systems
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                  MQTT & IoT Protocols
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                  Circuit Design
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                  Sensor Integration
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {}
      <section id="projects" className="py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto">
        <h2 ref={revealRef} className="text-3xl font-bold mb-12 text-center reveal-element">
          <span className="bg-gradient-to-r from-cyan-400 to-purple-500 text-transparent bg-clip-text">Featured Projects</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {}
          {visibleProjects.map((project, index) => (
            <div 
              key={project.id} 
              ref={revealRef}
              className={`bg-gray-800 rounded-lg overflow-hidden shadow-lg border border-gray-700 ${project.borderHoverColor} transition-all duration-300 reveal-element`}
              style={{ transitionDelay: `${index * 0.1}s` }}
            >
              <div className={`h-48 bg-gradient-to-r ${project.color} relative overflow-hidden`}>
                <img 
                  src={project.imageUrl} 
                  alt={project.title} 
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">{project.title}</h3>
                <p className="text-gray-300 mb-4">{project.description}</p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.technologies.map(tech => (
                    <span key={tech} className={`bg-gray-700 ${project.textColor} text-xs px-3 py-1 rounded-full`}>
                      {tech}
                    </span>
                  ))}
                </div>
                <div className="flex justify-between">
                  <a href={project.codeLink} className={`${project.textColor} ${project.hoverColor} flex items-center`}>
                    <Github size={18} className="mr-1" /> View Code
                  </a>
                  <a href={project.liveLink} className={`${project.textColor} ${project.hoverColor} flex items-center`}>
                    {project.linkText} <ExternalLink size={18} className="ml-1" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {}
        {projects.length > 4 && (
          <div className="flex justify-center mt-12">
            <button 
              onClick={toggleShowAllProjects}
              className="group flex items-center space-x-2 bg-gray-800 hover:bg-gray-700 text-gray-300 hover:text-white px-6 py-3 rounded-full transition-all duration-300 border border-gray-700 hover:border-cyan-500 shadow-lg"
            >
              <span>{showAllProjects ? 'View Less' : 'View More'}</span>
              <div className={`transform transition-transform duration-300 ${showAllProjects ? 'rotate-180' : ''}`}>
                <ChevronDown size={20} className={`text-cyan-400 group-hover:text-cyan-300`} />
              </div>
            </button>
          </div>
        )}
      </section>

      {}
      <section id="contact" className="py-16 bg-gray-800 bg-opacity-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 ref={revealRef} className="text-3xl font-bold mb-8 text-center reveal-element">
            <span className="bg-gradient-to-r from-cyan-400 to-purple-500 text-transparent bg-clip-text">Get In Touch</span>
          </h2>

          <div ref={revealRef} className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700 reveal-element">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8 items-center">
              <div>
                <h3 className="text-xl font-semibold mb-4 text-cyan-400 text-center">Let's Build Something Amazing Together</h3>
                <p className="text-gray-300 mb-6 text-center">Whether you have a project in mind or just want to connect, I'm always open to discussing new opportunities and challenges.</p>

                <div ref={revealRef} className="space-y-4 max-w-md mx-auto staggered-reveal reveal-element">
                  <a href="mailto:aaron123thomas098@gmail.com" className="flex items-center text-gray-300 hover:text-cyan-400 transition-colors duration-300">
                    <Mail size={20} className="mr-3" />
                    aaron123thomas098@gmail.com
                  </a>
                  <a href="https://github.com/arxhr007" className="flex items-center text-gray-300 hover:text-cyan-400 transition-colors duration-300">
                    <Github size={20} className="mr-3" />
                    github.com/arxhr007
                  </a>
                  <a href="https://linkedin.com/in/aaron-thomas-16971233a" className="flex items-center text-gray-300 hover:text-cyan-400 transition-colors duration-300">
                    <Linkedin size={20} className="mr-3" />
                    linkedin.com/in/aaron-thomas-parakkal
                  </a>
                  <a href="https://instagram.com/_arxhr007_" className="flex items-center text-gray-300 hover:text-cyan-400 transition-colors duration-300">
                    <Instagram size={20} className="mr-3" />
                    instagram.com/_arxhr007_
                  </a>
                  <a href="https://t.me/arxhr007" className="flex items-center text-gray-300 hover:text-cyan-400 transition-colors duration-300">
                    <MessageCircle size={20} className="mr-3" />
                    t.me/arxhr007
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {}
      <footer className="py-8 border-t border-gray-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <span className="font-bold text-xl text-cyan-400">ARXHR<span className="text-purple-400">007</span></span>
              <p className="text-gray-400 text-sm mt-1">Building secure and scalable web solutions</p>
            </div>

          </div>
          <div className="mt-8 text-center text-gray-500 text-sm">
            © {new Date().getFullYear()} Arxhr007. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
    )}
    </>
      );
    };

    export default Portfolio;